/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DocArrowConvertIcon24Solid = forwardRef('DocArrowConvertIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M20 8.55v-.04l-6.45-6.45V7.3c0 .69.56 1.25 1.25 1.25H20Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 2h4.05v5.3a2.75 2.75 0 0 0 2.75 2.75H20V18a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4v-2h6.372l-1.58 1.58a1 1 0 1 0 1.415 1.414l2.756-2.757a1.75 1.75 0 0 0 0-2.474l-2.756-2.757a1 1 0 1 0-1.414 1.414l1.58 1.58H4v-4a2 2 0 1 0 0 4v2a4 4 0 0 1 0-8V6a4 4 0 0 1 4-4Z" })));
});
